import { render, staticRenderFns } from "./multiRegimental.vue?vue&type=template&id=595ce6c0&scoped=true"
import script from "./multiRegimental.vue?vue&type=script&lang=js"
export * from "./multiRegimental.vue?vue&type=script&lang=js"
import style0 from "./multiRegimental.vue?vue&type=style&index=0&id=595ce6c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ce6c0",
  null
  
)

export default component.exports